export default "__VITE_ASSET__BhBkw2JQ__";